var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-tile',{on:{"click":_vm.removeSlide}},[_c('v-list-tile-title',{staticClass:"body-1"},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-trash-can")]),_c('span',[_vm._v("Remove")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }